import { useEffect } from 'react';

const shouldBypassAnchor = (anchor) => {
  if (!anchor) {
    return true;
  }

  const href = anchor.getAttribute('href');
  if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
    return true;
  }

  if (anchor.hasAttribute('download')) {
    return true;
  }

  if (anchor.target && anchor.target.toLowerCase() !== '_self') {
    return true;
  }

  return false;
};

const useFallbackNavigationGuards = ({ when, message, hasNativeBlock }) => {
  useEffect(() => {
    if (!when) {
      return undefined;
    }

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };

    const clickHandler = (event) => {
      if (hasNativeBlock || event.defaultPrevented) {
        return;
      }

      if (event.button !== 0 || event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) {
        return;
      }

      if (!(event.target instanceof Element)) {
        return;
      }

      const anchor = event.target.closest('a[href]');
      if (shouldBypassAnchor(anchor)) {
        return;
      }

      const nextUrl = new URL(anchor.href, window.location.href);
      const currentUrl = new URL(window.location.href);

      if (nextUrl.origin !== currentUrl.origin) {
        return;
      }

      if (
        nextUrl.pathname === currentUrl.pathname &&
        nextUrl.search === currentUrl.search &&
        nextUrl.hash === currentUrl.hash
      ) {
        return;
      }

      if (!window.confirm(message)) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    const popStateHandler = () => {
      if (hasNativeBlock) {
        return;
      }

      if (!window.confirm(message)) {
        window.history.go(1);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    document.addEventListener('click', clickHandler, true);
    window.addEventListener('popstate', popStateHandler);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      document.removeEventListener('click', clickHandler, true);
      window.removeEventListener('popstate', popStateHandler);
    };
  }, [when, message, hasNativeBlock]);
};

export const QuickNavigationPrompt = ({ when, message }) => {
  useFallbackNavigationGuards({ when, message, hasNativeBlock: false });
  return null;
};

const NavigationPrompt = ({ when, message }) => {
  useFallbackNavigationGuards({ when, message, hasNativeBlock: false });

  return null;
};

export default NavigationPrompt;
